<template>
  <sui-page>
    <sui-page-header :pageId="contextPageId" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SITE')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <cmp-site-select
              ref="siteSelect"
              :pageId="ruterOriginPageId"
              :selected="frame0.selectData.COD_SITE"
              :initialSelectedIndex="0"
              :disabled="true"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-module-submodule-select
              ref="smComboFrame0"
              :pageId="contextPageId"
              :selectedMd="frame0.selectData.COD_MDLE"
              :selectedSmd="frame0.selectData.COD_SMDLE"
              defaultMdOption="all"
              defaultSmdOption="all"
              :disabled="isDisabled"
              :disabledMd="isModuleDisabled"
              class="dp_flex"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MGT_YN')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-yn-select
              ref="mgtYnSelect"
              defaultOption="all"
              :selected="frame0.selectData.COD_ATTH_ITEM_MGT_YN"
            />
          </div>
        
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_IMG_YN')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-yn-select
              ref="imgYnSelect"
              defaultOption="all"
              :selected="frame0.selectData.COD_IMG_PRVW_APPY_YN"
              :initialSelectedIndex="0"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEARCH_COND')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="condType"
              :selected="frame0.selectData.COD_COND"
              codeId="COD_ATTH_GRP_SEARCH_COND"
              defaultOption="all"
              :initialSelectedIndex="0"
              style="width:58%"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model.trim="frame0.searchText"
              :disabled="false"
              :readonly="false"
              maxlength="50"
              @keyup.enter="onClickSearch('button')"
              @keyup="onKeyUpInput"
            />
          </div>        
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onClickReset"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="$options.name"
            type="button"
            class="comm_btn_Scr"
            :disabled="isSearchDisabled"
            @click="onClickSearch('button')"
          >
            {{ $t("MSG_BTN_SEARCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB10" />
      <div class="comm_shut_wrap">
        <div class="inbox">
          <div class="comm_title_wrap">
            <h4>{{ $t("MSG_TXT_ATTH_GRP_LIST") }}</h4>
          </div>
          <sui-grid
            ref="grid0"
            :columns="gridColumns0"
            :columnsautoresize="true"
            width="100%"
            :columnsresize="true"
            :showCountControl="true"
            :showDisplayCountControl="false"
            :dataset="'dsAttachGroupSite'"
            :initial-pagesize="10"
          >
            <div class="btn_wrapR">
              <sui-button
                type="button"
                class="comm_btn_gridTop"
                @click="onClickDetail"
              >
                {{ $t("MSG_BTN_DTL") }}
              </sui-button>
            </div>
          </sui-grid>
        </div>
        <div class="emptybox" />
        <div class="inbox">
          <div class="comm_title_wrap">
            <h4>{{ $t("MSG_TXT_ATTH_GRP_ITEM") }}</h4>
          </div>
          <sui-grid
            ref="grid1"
            :columns="gridColumns1"
            :columnsautoresize="true"
            width="100%"
            :columnsresize="true"
            :showCountControl="true"
            :showDisplayCountControl="false"
            :dataset="'dsAttachItem'"
            :initial-pagesize="10"
          />
        </div>
      </div>
      <div class="comm_btn_wrap">
        <sui-button
          v-permission:update="contextPageId"
          type="button"
          class="comm_btn_solid"
          @click="onClickMod"
        >
          {{ $t("MSG_BTN_MDFC") }}
        </sui-button>
      </div>
    </sui-page-contents>
    <sui-popup
      v-model="isShownPopupDetail"
      :title="$t('MSG_TIT_ATTH_GRP_DTL')"
    >
      <p01
        :pageId="contextPageId"
        :selectedGridRowData="selectedGridRowData"
        :siteId="siteId"
        @onClickClose="onClickClose('isShownPopupDetail')"
      />
    </sui-popup>

    <sui-popup
      v-model="isShownPopupMod"
      :title="$t('MSG_TIT_SITE_ATTH_ITEM_SELT')"
    >
      <p02
        :pageId="contextPageId"
        :selectedGridRowData="selectedGridRowData"
        :siteId="siteId"
        @onRowReSelect="onRowReSelect"
        @onClickClose="onClickClose('isShownPopupMod')"
      />
    </sui-popup>
  </sui-page>
</template>
<script>
// import - libraries (node modules)
// import - local files (js, vue, ...)
import p01 from './components/PGE_CMD_00006_P01';
import p02 from './components/PGE_CMD_00006_P02';
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

const dateFields = [
  'firstRegistrationDTM', 'finalModificationDTM', 'pageUsePriodStartDatetime', 'pageUsePriodFinishDatetime',
];
export default {
  name: 'PGE_CMD_00006', // eslint-disable-line vue/name-property-casing
  components: { p01, p02 },
  extends: BasePage,
  data() {
    return {
      pageTitle: this.$t('MSG_TIT_SITE_ATTH_ITEM_MGT'), // eslint-disable-line vue/name-property-casing,
      ruterOriginPageId: 'PGE_CMD_00006',
      isDisabled: false,
      isModuleDisabled: false,
      isSearchDisabled: false,
      showCheckIdModal: false,
      isShownPopupDetail: false,
      isShownPopupMod: false,
      selectedGridRowData: '',
      selectedStandardFormData: '',
      siteId: '',
      // 페이지 에서 사용하는 code 목록이 저장 될 field
      codes: {
        COD_SITE: [],
      },
      frame0: {
        selectData: {
          COD_COND: {
            label: '',
            key: '',
          },
          COD_MDLE: {
            label: '',
            key: '',
          },
          COD_SMDLE: {
            label: '',
            key: '',
          },
          COD_SITE: {
            label: '',
            key: '',
          },
          COD_ATTH_ITEM_MGT_YN: {
            label: '',
            key: 'Y',
          },
          COD_IMG_PRVW_APPY_YN: {
            label: '',
            key: '',
          },
        },
        searchText: '',
      },
      localdata0: [],
      localdata1: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_MDLE'),
        datafield: 'moduleName',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_SMDLE'),
        datafield: 'subModuleName',
        width: '100px',
      },
      //  {
      //   text: this.$t('MSG_TXT_ATTH_GRP_ID'),
      //   datafield: 'attachGroupId',
      // },
      {
        text: this.$t('MSG_TXT_ATTH_GRP_NM'),
        datafield: 'attachGroupName',
      }, {
        text: this.$t('MSG_TXT_MGT_YN'),
        datafield: 'attachItemManagementName',
        width: '80px',
      }, {
        text: this.$t('MSG_TXT_IMG'),
        datafield: 'imagePreviewApplyName',
        width: '80px',
      }],
      gridColumns1: [
      // {
      //   text: this.$t('MSG_TXT_ITEM_ID'),
      //   datafield: 'attachItemId',
      // },
        {
          text: this.$t('MSG_TXT_ITEM_NM'),
          datafield: 'attachItemName',
          createwidget: (row, column, value, htmlElement) => {
            utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
              handler: this.onGridButtonClick,
              type: 'link',
            }, this.dsAttachItem, this.$refs.grid1);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        }, {
          text: this.$t('MSG_TXT_HDQT_CNTL_YN'),
          datafield: 'headquarterControlName',
          width: '100px',
        }, {
          text: this.$t('MSG_TXT_NCSR_YN'),
          datafield: 'headquarterEssentialName',
          width: '100px',
        }, {
          text: this.$t('MSG_TXT_ARRAY_ORDER'),
          datafield: 'arrayalOrder',
          width: '80px',
        }, {
          text: this.$t('MSG_TXT_EXTS'),
          datafield: 'attachPossibilityExtensionCode',
          width: '80px',
        }],
    };
  },
  mounted() {
    // 주로 데이터 패치 등을 함
    this.dsAttachGroupSite.$on(this.dsAttachGroupSite.EVENTS.SELECTION_CHANGED, this.datasetSelectionChanged);

    this.setSessionSite();
    this.setRouterOriginPageId();
    this.loadData();
  },
  destroyed() {
    // 남아 있는 자원 반환
    this.dsAttachGroupSite.$off(this.dsAttachGroupSite.EVENTS.SELECTION_CHANGED, this.datasetSelectionChanged);
  },
  methods: {
    setRouterOriginPageId() {
      const routerOriginPageId = utils.getParameter(this, 'routerOriginPageId');

      if (routerOriginPageId !== undefined && !utils.isEmpty(routerOriginPageId)) {
        this.ruterOriginPageId = routerOriginPageId;
      }
    },
    // 모듈/서브모듈 parameter 존재 하는 경우 해당 data set 및 disable
    loadData() {
      // get contents data, grid etc..
      const paramModuleCode = utils.getParameter(this, 'module');
      const paramsubModuleCode = utils.getParameter(this, 'subModule');

      if (!utils.isEmpty(paramModuleCode) && !utils.isEmpty(paramsubModuleCode)) {
        this.$refs.smComboFrame0.selectMdSmd(paramModuleCode, paramsubModuleCode);
        this.isDisabled = true;
      } else if (!utils.isEmpty(paramModuleCode) && utils.isEmpty(paramsubModuleCode)) {
        this.$refs.smComboFrame0.selectMdSmd(paramModuleCode, paramsubModuleCode);
        this.isModuleDisabled = true;
      } else if (utils.isEmpty(paramModuleCode) && !utils.isEmpty(paramsubModuleCode)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_IF_EXIST_PSBL'), this.$t('MSG_TXT_MDLE')));
        this.isDisabled = true;
        this.isSearchDisabled = true;
      }
    },
    /**
     * 사업장 코드 기본 값(사용자 세션 사업장 코드 값) 설정
     */
    setSessionSite() {
      // 사용자 세션 사업장 코드 값 설정 -> 세션설정 정보가 없을 경우 수원(C100SW)로 지정(임시)
      const sessionSiteId = this.$store.getters.userInfo.siteId;
      this.frame0.selectData.COD_SITE.key = sessionSiteId;
    },
    /**
     * 리셋
     */
    onClickReset() {
      utils.forEach(this.frame0, (value, key) => {
        if (!utils.isEqual(key, 'selectData')) {
          this.frame0[key] = '';
        } else {
          // this.$refs.smComboFrame0.reset();
          this.frame0.selectData.COD_MDLE.key = 'ALL';
          this.frame0.selectData.COD_SMDLE.key = 'ALL';
          this.$refs.mgtYnSelect.reset();
          this.$refs.imgYnSelect.reset();
          this.$refs.condType.reset();
        }
      });

      this.loadData();
    },
    /**
     * 첨부그룹 목록 조회
     */
    onClickSearch(type) {
      const queryParams = {
        moduleCode: utils.trim(this.frame0.selectData.COD_MDLE.key),
        subModuleCode: utils.trim(this.frame0.selectData.COD_SMDLE.key),
        attachItemManagementYn: utils.trim(this.frame0.selectData.COD_ATTH_ITEM_MGT_YN.key),
        imagePreviewApplyYn: utils.trim(this.frame0.selectData.COD_IMG_PRVW_APPY_YN.key),
        searchCondition: utils.trim(this.frame0.selectData.COD_COND.key),
        attachGroupId: this.frame0.searchText,
        attachGroupName: this.frame0.searchText,
        siteId: this.frame0.selectData.COD_SITE.key,
      };

      this.siteId = this.frame0.selectData.COD_SITE.key;

      http.request(this.contextPageId, 'DTS_CMD_00007', {
        query: queryParams,
      }).then(res => {
        utils.dateformatToClientInArray(res.data, dateFields);// 컴포넌트가 사용하는 date 값으로 변환
        this.dsAttachGroupSite.setRawData(res.data); // 데이터 셋에 데이터를 넣는 함수

        if (this.dsAttachGroupSite.data.length > 0) {
          if (utils.isEqual(type, 'button')) {
            this.dsAttachGroupSite.clearSelection();
            this.dsAttachGroupSite.setSelectedIndexes([0]);
          }
        } else {
          this.dsAttachItem.setRawData([]);
        }
      });
    },
    /**
     * 첨부그룹 목록 grid selected event
     */
    datasetSelectionChanged(data) {
      const { attachGroupId } = this.dsAttachGroupSite.data[data.newSelections];
      const { siteId } = this;

      this.itemListSearch(attachGroupId, siteId);

      this.selectedGridRowData = this.dsAttachGroupSite.data[data.newSelections];
    },
    /**
     * 첨부그룹 첨부항목 목록 조회
     */
    itemListSearch(attachGroupId, siteId) {
      http.request(this.contextPageId, 'DTS_CMD_00014', {
        path: {
          'attach-group-id': attachGroupId,
        },
        query: {
          siteId,
        },
      }).then(res => {
        this.dsAttachItem.setRawData(res.data); // 데이터 셋에 데이터를 넣는 함수
      });
    },
    /**
     * 팝업 호출
     */
    onClickPopupOpen(data) {
      this[data] = true;
    },
    onClickClose(data) {
      this[data] = false;
    },
    /**
     * 첨부그룹 상세 팝업 호출
     */
    onClickDetail() {
      if (this.dsAttachGroupSite.getSelectedIndexes().length > 0) {
        this.onClickPopupOpen('isShownPopupDetail');
      } else {
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));
      }
    },
    /**
     * 수정
     * 사업장 별 첨부항목 선택 팝업 호출
     */
    onClickMod() {
      if (this.dsAttachGroupSite.getSelectedIndexes().length > 0) {
        this.onClickPopupOpen('isShownPopupMod');
      } else {
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));
      }
    },
    /**
     * 첨부항목 목록 재 조회
     */
    onRowReSelect() {
      this.selectedGridRowData = this.dsAttachGroupSite.getSelectedRow();
      const { attachGroupId } = this.selectedGridRowData;
      const { siteId } = this;

      this.itemListSearch(attachGroupId, siteId);
    },
    /**
     * 검색조건 특수문자 입력 제한
     */
    onKeyUpInput() {
      const searchFieldNewText = this.frame0.searchText;

      if (utils.isExistSpecialChar(searchFieldNewText)) {
        utils.messageBox('warning', this.$t('MSG_ALT_NO_SPECL_CHAR_SRCH'), this.$t('MSG_ALT_SPECL_CHAR_LIST'), () => {
          this.frame0.searchText = this.searchFieldOldText;
          this.$refs.searchField.setFocus();
        });
      } else {
        this.searchFieldOldText = searchFieldNewText;
      }
    },
    checkEditableFunction() {
      return true;
    },
    /**
     * 첨부그룹 별 항목 버튼
     * EVENT
     */
    onGridButtonClick() {
      this.onClickMod();
    },
  },
  datasets: [{
    id: 'dsAttachGroupSite',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'attachGroupId', map: 'attachGroupId' },
      { type: 'string', name: 'attachGroupName', map: 'attachGroupName' },
      { type: 'string', name: 'moduleCode', map: 'moduleCode' },
      { type: 'string', name: 'moduleName', map: 'moduleName' },
      { type: 'string', name: 'subModuleCode', map: 'subModuleCode' },
      { type: 'string', name: 'subModuleName', map: 'subModuleName' },
      { type: 'string', name: 'attachItemManagementYn', map: 'attachItemManagementYn' },
      { type: 'string', name: 'imagePreviewApplyYn', map: 'imagePreviewApplyYn' },
      { type: 'string', name: 'downloadHistoryManagementYn', map: 'downloadHistoryManagementYn' },
      { type: 'string', name: 'downloadReasonInputYn', map: 'downloadReasonInputYn' },
      { type: 'string', name: 'attachGroupContent', map: 'attachGroupContent' },
      { type: 'string', name: 'attachGroupMultiLanguageId', map: 'attachGroupMultiLanguageId' },
      { type: 'string', name: 'attachItemTypeCodeValidityValue', map: 'attachItemTypeCodeValidityValue' },
      { type: 'string', name: 'headquarterEssentialYn', map: 'headquarterEssentialYn' },
      { type: 'string', name: 'attachRestrictionSize', map: 'attachRestrictionSize' },
      { type: 'string', name: 'attachPossibilityExtensionCode', map: 'attachPossibilityExtensionCode' },
      { type: 'string', name: 'attachExcludePossibilityYn', map: 'attachExcludePossibilityYn' },
      { type: 'string', name: 'attachItemMultiLanguageId', map: 'attachItemMultiLanguageId' },
      { type: 'string', name: 'attachDocumentTypeCode', map: 'attachDocumentTypeCode' },
      { type: 'string', name: 'firstRegistrationDTM', map: 'firstRegistrationDTM' },
      { type: 'string', name: 'firstRegistrationUserId', map: 'firstRegistrationUserId' },
      { type: 'string', name: 'finalModificationDTM', map: 'finalModificationDTM' },
      { type: 'string', name: 'finalModificationUserId', map: 'finalModificationUserId' },
      { type: 'string', name: 'attachItemManagementName', map: 'attachItemManagementName' },
      { type: 'string', name: 'imagePreviewApplyName', map: 'imagePreviewApplyName' },
      { type: 'string', name: 'attachGroupDeterminName', map: 'attachGroupDeterminName' },
      { type: 'string', name: 'knoxIdModification', map: 'knoxIdModification' },
      { type: 'string', name: 'userNameModification', map: 'userNameModification' },
      { type: 'string', name: 'userGlobalNameModification', map: 'userGlobalNameModification' },
      { type: 'string', name: 'departmentNameModification', map: 'departmentNameModification' },
      { type: 'string', name: 'departmentEnglishNameModification', map: 'departmentEnglishNameModification' },
      { type: 'string', name: 'knoxIdRegistration', map: 'knoxIdRegistration' },
      { type: 'string', name: 'userNameRegistration', map: 'userNameRegistration' },
      { type: 'string', name: 'userGlobalNameRegistration', map: 'userGlobalNameRegistration' },
      { type: 'string', name: 'departmentNameRegistration', map: 'departmentNameRegistration' },
      { type: 'string', name: 'departmentEnglishNameRegistration', map: 'departmentEnglishNameRegistration' },
      { type: 'string', name: 'displayLanguageIdRegistration', map: 'displayLanguageIdRegistration' },
      { type: 'string', name: 'displayLanguageIdModification', map: 'displayLanguageIdModification' },
    ],
  }, {
    id: 'dsAttachItem',
    type: 'local',
    data: 'localdata1',
    datafields: [
      { type: 'string', name: 'attachItemId', map: 'attachItemId' },
      { type: 'string', name: 'attachGroupId', map: 'attachGroupId' },
      { type: 'string', name: 'headquarterControlYn', map: 'headquarterControlYn' },
      { type: 'string', name: 'headquarterEssentialYn', map: 'headquarterEssentialYn' },
      { type: 'string', name: 'attachExcludePossibilityYn', map: 'attachExcludePossibilityYn' },
      { type: 'string', name: 'arrayalOrder', map: 'arrayalOrder' },
      { type: 'string', name: 'attachPossibilityExtensionCode', map: 'attachPossibilityExtensionCode' },
      { type: 'string', name: 'attachItemName', map: 'attachItemName' },
      { type: 'string', name: 'headquarterControlName', map: 'headquarterControlName' },
      { type: 'string', name: 'headquarterEssentialName', map: 'headquarterEssentialName' },
    ],
  }],
};
</script>
<style scoped>
</style>
